module.exports = __webpack_public_path__ + "lab-icon.png?fa368e296936e97f8ef1850f1d517703";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lab-icon.png
// module id = 23
// module chunks = 0